// extracted by mini-css-extract-plugin
module.exports = {"xtScrollBarY":"spot_xtScrollBarY__Dz0YY","main":"spot_main__i_XIE","nav":"spot_nav__xd8mB","li":"spot_li__w4XwX","noData":"spot_noData__KVAmd","totalBtc":"spot_totalBtc__yJOND"};